type SnowplowGzipEnvValue = 'true' | 'false' | undefined;

export function resolveSnowplowGzipEnabled(value: SnowplowGzipEnvValue): boolean {
  return value !== 'false';
}
